import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify, removeNotification } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import { getAPITimeRange } from 'services/config/selectors';
import { getCurrentEntityName, getCurrentEntityId, getCurrentEntityMeta } from 'services/entities/selectors';

import {
    requestPDFComplete,
    actions,
    removeNextPendingAction,
    addPendingAction,
} from './duck';

import {
    requestPDFEndpoint,
    getConfigs,
    activeRequestCount,
    getNextPendingAction,
    getDynamicProfilesCount
} from './selectors';

export function* requestPDF(api, action) {
    const requestCount = yield select(activeRequestCount);

    if (requestCount > 0) {
        yield put(notify({
            id: 'downloadingPDFwaiting',
            message: 'Crunching the data. Please wait...',
            status: 'success',
            dismissAfter: 0
        }));
        yield put(addPendingAction(action));
        return;
    }

    const entityMeta = yield select(getCurrentEntityMeta);
    if (entityMeta.meta.showSocialExpandModules === false) {
        entityMeta.social.objectives = [];
    }
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'post',
                url: yield select(requestPDFEndpoint, action.payload),
                data: {
                    meta: {
                        ...(action.payload.meta || {}),
                        ...(yield select(getAPITimeRange)),
                        entityName: yield select(getCurrentEntityName),
                        entityId: yield select(getCurrentEntityId),
                        entityMeta,
                        dynamicProfilesCount: yield select(getDynamicProfilesCount)
                    },
                    configs: yield select(getConfigs)
                }
            }
        );

        yield put(removeNotification('downloadingPDFwaiting'));

        const pdfWindow = window.open(result.data.url);
        if (!pdfWindow) {
            yield put(notify({
                message: 'Please allow popups to view the report',
                status: 'error'
            }));
        }
    } catch (err) {
        yield put(removeNotification('downloadingPDFwaiting'));
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }

    yield put(requestPDFComplete());
}

export function* checkPendingActions() {
    try {
        const requestCount = yield select(activeRequestCount);
        const nextPendingAction = yield select(getNextPendingAction);

        if (requestCount > 0 || !nextPendingAction) {
            return; // do nothing
        }

        yield put(removeNextPendingAction());
        yield put(nextPendingAction);
    } catch (err) {
        yield put(notify(sagaError(err)));
    }
}

export default function* exportSaga({ api }) {
    yield all([
        takeLatest(actions.REQUEST_PDF, requestPDF, api),
        takeLatest(actions.DECREASE_ACTIVE_REQUEST_COUNT, checkPendingActions, api),
    ]);
}



// WEBPACK FOOTER //
// ./src/services/exports/saga.js